import AdminUpdatePasein from "../../components/AdminPurchaseInvoice/AdminPurchaseInvoiceUpdate";

export default function UpdatePasien() {
  return (
    <div style={{backgroundColor:"white"}}>
      <AdminUpdatePasein/>
    </div>
  );
}
